<template>
  <component
    :is="hotspotType"
    :id="id"
    :icons="icons"
    :title="title"
    :trigger="trigger"
    :placement="placement"
    :submittedMessage="submitted_message"
    :class="{ hotspot: !isBlockComponent, hotspot_block: isBlockComponent }"
  >
    <slot></slot>
  </component>
</template>

<script>
/*
  This would be your hotspot component.
  Within here, you might have a dynamic <component...> that switches with `:is="type"`
  But for simplicity, let's assume it just renders your emoji feedback control.

  Any attributes that were included in the <hotspot> tag (id, type, icons) become props that you can access here
  
  The output here is just for testing to show that the values are handled correctly
  And the <slot> content shoudl be used to render whatever was between the <hotspot> tags
*/
import Emojis from './Emojis.vue'
import Comment from './Comment.vue'
import CommentBlock from './CommentBlock.vue'
import EmojisBlock from './EmojisBlock.vue'
import slugify from '@/common/utils/slugify'

export default {
  props: [
    'id',
    'type',
    'title',
    'icons',
    'trigger',
    'placement',
    'submitted_message',
  ],

  data: () => ({
    blockComponents: { CommentBlock, EmojisBlock },
  }),
  components: {
    Emojis,
    Comment,
    CommentBlock,
    EmojisBlock,
  },

  computed: {
    isBlockComponent() {
      var ht = this.hotspotType
      return !!this.blockComponents[ht]
    },
    hotspotType() {
      const cleanType = slugify(this.type)

      if (cleanType == 'emoji') {
        return 'Emojis'
      } else if (cleanType == 'comment') {
        return 'Comment'
      } else if (cleanType == 'comment-block') {
        return 'CommentBlock'
      } else if (cleanType == 'emoji-block') {
        return 'EmojisBlock'
      } else {
        throw new Error('Hotspot. Unknown hotspot type: ' + cleanType)
        return null
      }
    },
  },

  mounted() {
    const cleanType = slugify(this.type)

    let errors = []

    if (!this.id) {
      errors.push('No id defined for this hotspot.')
    }
    if (!this.type) {
      errors.push('No type defined for this hotspot.')
    }
    if (!this.icons && cleanType == 'emoji') {
      errors.push('No icons defined for this hotspot.')
    }

    if (errors.length > 0) {
      let errorString = errors.join(' ')
      throw new Error(errorString)
    }
  },
}
</script>
<style scoped>
.hotspot-wrapper {
  color: red;
  display: inline;
}

.hotspot-info {
  font-size: 10px;
  color: #484848;
}
</style>
<style>
.hotspot {
  background-color: var(--primary-color);
  padding: 0.15em;
  display: inline;
}
</style>
